export const FETCH_LISTING = 'LISTINGS:FETCH_LISTING';
export const FETCH_LISTING_ABORT = 'LISTINGS:FETCH_LISTING_ABORT';

export const FETCH_LISTING_REJECTED = 'LISTINGS:FETCH_LISTING_REJECTED';
export const FETCH_LISTING_FULFILLED = 'LISTINGS:FETCH_LISTING_FULFILLED';
export const FETCH_LISTING_PENDING = 'LISTINGS:FETCH_LISTING_PENDING';

export const LOAD_MORE_ITEMS = 'LISTINGS:LOAD_MORE_ITEMS';

export const LOAD_MORE_ITEMS_REJECTED = 'LISTINGS:LOAD_MORE_ITEMS_REJECTED';
export const LOAD_MORE_ITEMS_FULFILLED = 'LISTINGS:LOAD_MORE_ITEMS_FULFILLED';
export const LOAD_MORE_ITEMS_PENDING = 'LISTINGS:LOAD_MORE_ITEMS_PENDING';

export const REMOVE_LISTING = 'LISTINGS:REMOVE_LISTING';
export const REMOVE_LISTING_PENDING = 'LISTINGS:REMOVE_LISTING_PENDING';
export const REMOVE_LISTING_REJECTED = 'LISTINGS:REMOVE_LISTING_REJECTED';
export const REMOVE_LISTING_FULFILLED = 'LISTINGS:REMOVE_LISTING_FULFILLED';

export const GLOBAL_ERROR_CODES = {
  GENERIC: 500,
  MAINTENANCE: 503,
  NOT_FOUND: 404,
};

export const GLOBAL_ERROR_TYPES = {
  TIMEOUT: 'Dependent Service Timeout',
};

export const LISTING_TYPES = {
  active: 'active',
  sales: 'sales',
  expired: 'expired',
  unsold: 'unsold',
};

export const UPDATED_VIEW = 'LISTINGS:UPDATED';
export const PRICING_VIEW = 'LISTINGS:PRICING';

export const ANALYTICS_EVENT = 'LISTINGS:ANALYTICS_EVENT';
export const ANALYTICS_PAGEVIEW = 'LISTINGS:ANALYTICS_PAGEVIEW';

export const PAYMENT_VIEW = 'LISTINGS:PAYMENT';

export const DONE = 'LISTINGS:DONE';
export const CANCEL = 'LISTINGS:CANCEL';

export const SHOW_LOADER = 'LISTINGS:SHOW_LOADER';
export const HIDE_LOADER = 'LISTINGS:HIDE_LOADER';

export const LISTING_UPDATED = 'LISTINGS:LISTING_UPDATED';

export const UPDATE_LISTING = 'LISTINGS:UPDATE_LISTING';
export const UPDATE_LISTING_ABORT = 'LISTINGS:UPDATE_LISTING_ABORT';
export const UPDATE_LISTING_PENDING = 'LISTINGS:UPDATE_LISTING_PENDING';
export const UPDATE_LISTING_REJECTED = 'LISTINGS:UPDATE_LISTING_REJECTED';
export const UPDATE_LISTING_FULFILLED = 'LISTINGS:UPDATE_LISTING_FULFILLED';

export const SET_CURRENT_LIST_TYPE = 'LISTINGS:SET_CURRENT_LIST_TYPE';
export const SET_UPDATED_LISTING_PRICE = 'LISTINGS:SET_UPDATED_LISTING_PRICE';

export const POSTING_STATUSES = {
  ACTIVE: 'POSTED',
  PENDING_POST: 'PENDING_POST',
  PENDING_SALE: 'PENDING_SALE',
  PENDING_SOLD: 'PENDING_SOLD',
  CANCELING_POST: 'CANCELING_POST',
  SOLD: 'SOLD',
  EXPIRED: 'EXPIRED',
  UNKNOWN: 'UNKNOWN',
  CANCELED: 'CANCELED',
};

export const ACTIVE_TAB_VALID_STATUSES = [
  POSTING_STATUSES.PENDING_POST,
  POSTING_STATUSES.ACTIVE,
  POSTING_STATUSES.CANCELING_POST,
  POSTING_STATUSES.PENDING_SALE,
  POSTING_STATUSES.SOLD,
  POSTING_STATUSES.PENDING_SOLD,
];

export const SOLD_TAB_VALID_STATUSES = [
  POSTING_STATUSES.SOLD,
  POSTING_STATUSES.PENDING_SALE,
];

export const EXPIRED_TAB_VALID_STATUSES = [
  POSTING_STATUSES.EXPIRED,
  POSTING_STATUSES.EXPIRED,
];

export const PAGE_OPTIONS = {
  payment: {
    displayOtherCountryConfirmContentLine2: false,
  },
};
